<div class="secondary-sidepanel--agent-transcript-panel">
    <div class="secondary-sidepanel__content pl-25 pr-25 --minimal">
      <div>
        <a class="close" (click)="onClose($event)"><i class="fa-regular fa-times"></i></a>
      </div>
      <h4 class="card-panel-title --minimal">Transcript Panel</h4>
      <div class="chat--row">
        <div *ngIf="transcriptData.length === 0" colspan="100%" align="center" class="transcript-container">
          <div class="single-message-center">
            <i class="no-data__icon fa-light fa-database"></i>
            No transcript available.
          </div>
        </div>
  
        <div colspan="11" *ngIf="transcriptData.length > 0" class="transcript-container">
          <div class="call-recroding-chat">
  
            <div class="call__recroding__header">
              <div class="call__recording__item">
                <div class="form-fields">
                  <span class="form-fields__search bg--white">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input [(ngModel)]="transcriptMessageSearch" (ngModelChange)="filterMessages()" type="text" placeholder="Search">
                  </span>
                </div>
              </div>
            </div>
            <ng-scrollbar track="all" visibility="hover" style="height: calc(100% - 50px);">
  
              <div class="chat__conversation-board">
                <div *ngFor="let m of filteredTranscriptData; let i = index" class="chat__conversation-board__message-container" [class]="m.userClass">
                  <div class="chat__conversation-board__message__context">
                    <div class="chat__conversation-board__message__bubble">
                      <div class="chat__conversation-board__message__person__initial">
                        {{ m.speaker }}
                      </div>
                      <p>{{m.message}}</p>
                    </div>
                  </div>
                  <div class="chat__conversation-board__message__time">
                    {{m.time}}
                  </div>
                </div>
              </div>
            </ng-scrollbar>
  
          </div>
        </div>
  
      </div>
    </div>
  </div>
  